var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppearance = function SvgAppearance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.953 7.18V.572h13.22V7.18zM11.933 10.906V7.18h2.24v3.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.953 13.797V.659H5.83v13.138z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.211 4.961h13.122v11.668H3.211z"
  })));
};
export default SvgAppearance;